import { useQuery } from '@tanstack/vue-query';

/**
 * Tanstack Query to load data from authenticated user
 */
export default function useLoadUser() {
    const { isAuthenticated } = useAuth();

    const query = useQuery({
        queryKey: [
            'user',
        ],
        queryFn: () => apiLoadUser(),
        staleTime: Infinity,
        enabled: isAuthenticated,
    });

    return {
        ...query,
        user: computed(() => query.data.value?.data),
    };
}
